import type { Store } from 'redux';
import type { Epic } from 'redux-observable';
import initiateStore from '@atlassian/jira-common-tangerine/src/state/initiate.tsx';
import rootReducer from './reducer/index.tsx';
import type { State, Action } from './types.tsx';

const createStore = (rootEpic?: Epic<Action, State>, initialState?: State): Store<State> =>
	initiateStore<State, Action, undefined>({
		initialState,
		appName: 'directories/boards-v2',
		rootReducer,
		rootEpic,
	});

export default createStore;
